




























































import { Component, Prop, Vue, Watch, Emit } from 'vue-property-decorator';
import ChangeRadio from '@/components/changeRadio/changeRadio.vue';
import { institutionServer, roleServe, userManagementServe } from '@/api/installServer';
import { arrayToTree } from '@/util/arrayToTree';
import { TableStripe } from '@/mixins/tableStripe';

@Component({
  components: { ChangeRadio },
  mixins: [TableStripe],
})
export default class Tree extends Vue {
  private visible = false;
  private input: any = '';
  private checkedText: any = [];
  private isCheckedId: any = '';
  private type: any = ''; // 传进来的查询类型

  private cities: any = []; // 展示可选的数据

  private created() {}

  private mounted() {}

  // 用户接口
  private getList(val?: any) {
    userManagementServe
      .sysAllUserList({
        size: 100,
        admin: true,
        search: val ? val : null,
      })
      .then((res: any) => {
        this.cities = res.data.records;
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  // 角色接口
  private getRoleList(val?: any) {
    roleServe
      .getAllRoleData({
        name: val ? val : null,
      })
      .then((res: any) => {
        this.cities = res.data;
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  // 机构接口
  private getInstitutionList(val?: any) {
    institutionServer
      .getAllData({
        name: val ? val : null,
      })
      .then((res: any) => {
        this.cities = arrayToTree(res.data);
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  /**
   * 打开窗口
   */
  private async showDialog(data: any, type: any) {
    this.type = type;
    if (type === '用户') {
      this.getList();
    }
    if (type === '角色') {
      this.getRoleList();
    }
    if (type === '机构') {
      this.getInstitutionList();
    }
    if (data) {
      setTimeout(() => {
        data.map((res: any) => {
          this.cities.map((re: any) => {
            if (res.objId === re.id) {
              (this.$refs.multipleTable as any).toggleRowSelection(re, true);
            }
          });
        });
      }, 100);
    } else {
    }
    this.visible = true;
  }

  /**
   * 关闭窗口
   */
  private hideDialog() {
    this.close();
  }

  /**
   * 【表单】弹窗关闭
   */
  private close() {
    this.visible = false;
    this.checkedText = [];
    this.isCheckedId = '';
    this.cities = [];
    this.type = '';
    this.input = '';
    (this.$refs.multipleTable as any).clearSelection();
  }

  private save() {
    const ListOne: any = []; // 存储id
    this.checkedText.map((res: any) => {
      ListOne.push({ objId: res.id, objName: res.username ? res.username : res.name });
    });

    this.$emit('getCheckOANode', ListOne);
    this.hideDialog();
  }

  /**
         @description: 选中的值
         @author: cxf
         @update: cxf 2021/7/12 14:04
         **/
  private handleSelectionChange(val: any) {
    this.checkedText = val;
  }

  /**
         @description: 对已选的数据进行删除
         @author: cxf
         @update: cxf 2021/7/12 15:15
         **/
  private indexDelete(arr: any, index: any) {
    arr.splice(index, 1);
    (this.$refs.multipleTable as any).clearSelection();
    if (arr) {
      arr.forEach((row: any) => {
        (this.$refs.multipleTable as any).toggleRowSelection(row);
      });
    } else {
      (this.$refs.multipleTable as any).clearSelection();
    }
    this.$forceUpdate();
  }

  // 监听 查询方法
  private searchDept(val: any) {
    if (this.type === '用户') {
      this.getList(val);
    }
    if (this.type === '角色') {
      this.getRoleList(val);
    }
    if (this.type === '机构') {
      this.getInstitutionList(val);
    }
  }
}
